import React from "react"

const ValidatorStatsContext = React.createContext()

export default ValidatorStatsContext
